"use strict";

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var Link_1 = require("./Link");

var styled_components_1 = __importStar(require("styled-components"));

var styled_component_helpers_1 = require("./styled-component-helpers"); // TODO a nicer way to add the svg then adding it into an img tag
// options: svg array, or maybe https://github.com/iconic/SVGInjector
// using svg directly allows for css manipulation of svg attributes


var IconLink = function IconLink(props) {
  var icon = props.icon,
      children = props.children,
      other = __rest(props, ["icon", "children"]);

  var IconLinkWrapper = props.url ? IconLinkStyled : IconLinkStyledSpan;
  return React.createElement(IconLinkWrapper, __assign({
    iconIncluded: !!icon
  }, other), icon && icon, React.createElement("span", {
    style: {
      color: "white"
    }
  }, children), !icon && arrowIcon);
};

exports["default"] = IconLink;
var t = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% { transform: translate(-935px,-5930px); animation-timing-function: cubic-bezier(0,0,0.58,1); }\n  11.1111% { transform: translate(-935px,-5930px); animation-timing-function: cubic-bezier(0,0,0.58,1); }\n  55.5555% { transform: translate(-905.5px,-5930px); animation-timing-function: cubic-bezier(0,0,0.58,1); }\n  66.6666% { transform: translate(-960.5px,-5930px); animation-timing-function: cubic-bezier(0.42,0,0.58,1); }\n  100% { transform: translate(-934.25px,-5930px); }\n"], ["\n  0% { transform: translate(-935px,-5930px); animation-timing-function: cubic-bezier(0,0,0.58,1); }\n  11.1111% { transform: translate(-935px,-5930px); animation-timing-function: cubic-bezier(0,0,0.58,1); }\n  55.5555% { transform: translate(-905.5px,-5930px); animation-timing-function: cubic-bezier(0,0,0.58,1); }\n  66.6666% { transform: translate(-960.5px,-5930px); animation-timing-function: cubic-bezier(0.42,0,0.58,1); }\n  100% { transform: translate(-934.25px,-5930px); }\n"])));
var o = styled_components_1.keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  0% { opacity: 1; animation-timing-function: cubic-bezier(0,0,0.58,1); }\n  10% { opacity: 1; animation-timing-function: cubic-bezier(0,0,0.58,1); }\n  30% { opacity: 0; animation-timing-function: cubic-bezier(0,0,0.58,1); }\n  60% { opacity: 0; animation-timing-function: cubic-bezier(0.42,0,0.58,1); }\n  100% { opacity: 1; }\n"], ["\n  0% { opacity: 1; animation-timing-function: cubic-bezier(0,0,0.58,1); }\n  10% { opacity: 1; animation-timing-function: cubic-bezier(0,0,0.58,1); }\n  30% { opacity: 0; animation-timing-function: cubic-bezier(0,0,0.58,1); }\n  60% { opacity: 0; animation-timing-function: cubic-bezier(0.42,0,0.58,1); }\n  100% { opacity: 1; }\n"])));
var padding = "16px";
var IconLinkStyled = styled_components_1["default"](Link_1.LinkStyled)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\n  display: ", ";\n  text-decoration: none;\n  padding: ", " 0;\n  cursor: pointer;\n\n  // If image is provided\n  ", "\n\n  // If image is not provided and it uses arrowIcon\n  ", ""], ["\n\n  display: ", ";\n  text-decoration: none;\n  padding: ", " 0;\n  cursor: pointer;\n\n  // If image is provided\n  ", "\n\n  // If image is not provided and it uses arrowIcon\n  ", ""])), function (props) {
  return props.inline ? "inline-flex" : "flex";
}, padding, function (props) {
  return props.iconIncluded && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      align-items: flex-end;\n      img,\n      svg {\n        width: 24px;\n        height: 24px;\n        margin-right: 12px;\n        vertical-align: middle;\n        cursor: pointer;\n        margin-bottom: 0;\n        display: inline !important;\n      }\n    "], ["\n      align-items: flex-end;\n      img,\n      svg {\n        width: 24px;\n        height: 24px;\n        margin-right: 12px;\n        vertical-align: middle;\n        cursor: pointer;\n        margin-bottom: 0;\n        display: inline !important;\n      }\n    "])));
}, function (props) {
  return !props.iconIncluded && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      align-items: center;\n\n      & > svg {\n        vertical-align: sub;\n        margin-left: 16px;\n        height: 24px;\n      }\n\n      & #teaser {\n        stroke: ", ";\n      }\n\n      .hasHover &:hover #PK_Kostenloses_Girokonto_1440_01_01 {\n        animation: ", " 0.5s linear both, ", " 0.5s linear both;\n      }\n    "], ["\n      align-items: center;\n\n      & > svg {\n        vertical-align: sub;\n        margin-left: 16px;\n        height: 24px;\n      }\n\n      & #teaser {\n        stroke: ", ";\n      }\n\n      .hasHover &:hover #PK_Kostenloses_Girokonto_1440_01_01 {\n        animation: ", " 0.5s linear both, ", " 0.5s linear both;\n      }\n    "])), styled_component_helpers_1.theme("textStyles.textBody.color"), t, o);
});
var IconLinkStyledSpan = IconLinkStyled.withComponent("span");
var arrowIcon = React.createElement("svg", {
  width: "40px",
  height: "16px",
  viewBox: "0 0 40 16"
}, React.createElement("g", {
  id: "PK_Kostenloses_Girokonto_1440_01_01",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-935.000000, -5930.000000)"
}, React.createElement("g", {
  id: "teaser",
  transform: "translate(0.000000, 5698.000000)",
  strokeWidth: "2"
}, React.createElement("g", {
  id: "Group-14",
  transform: "translate(735.000000, 80.000000)"
}, React.createElement("g", {
  id: "Group-76",
  transform: "translate(0.000000, 148.000000)"
}, React.createElement("g", {
  id: "Group-8",
  transform: "translate(209.000000, 12.000000) scale(-1, 1) translate(-209.000000, -12.000000) translate(197.000000, 0.000000)"
}, React.createElement("g", {
  id: "Arrow-11",
  transform: "translate(3.000000, 5.000000)"
}, React.createElement("path", {
  d: "M17.5,7 L0,7",
  id: "Stroke-2"
}), React.createElement("polyline", {
  id: "Stroke-4",
  points: "7 0 0 7.056 6.88888889 14"
}))))))));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;